import { UploadFilesCard } from './UploadFilesCard';
import { FileIcon } from '../../../icons/fileIcon';
import { Button } from '../../ui/Button';
import { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getRequiredDocuments } from '../../../transactions/offer/offer';
import { useSaveFileFn } from '../../../hooks/react-query/useOffer';
import { useToast } from '../../ui/Toast/useToast';
import { TooltipComponent } from '../../ui/Tooltip';
import Loader from '../../elements/loader';

export const DocumentationSecond = ({ onStepCompleted, message, isLoading }) => {
  const [save, setSave] = useState(false)
  const { orderId } = useParams();

  const { mutate: saveFile } = useSaveFileFn();
  const { toast } = useToast();
  const [items,setItems] = useState([])

  const { data: documentData} = useQuery({
    queryKey: [],
    queryFn: () => getRequiredDocuments(orderId),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: orderId !== undefined
  });


  useEffect(() => {
    if (documentData) {
      const itemsList = documentData.data.requiredDocuments.map(item => {
        const currentDocuments = documentData.data.currentDocuments.filter(current => current.docCode === item);
        const documentRequiredNumbers = documentData.data.documentRequiredNumbers[item].min;
        const documentMaxNumber = documentData.data.documentRequiredNumbers[item].max;

        let initArray = [...currentDocuments];
        if (currentDocuments.length > documentMaxNumber) {
          initArray = initArray.slice(0,documentMaxNumber)
        } else {
          while (initArray.length < documentRequiredNumbers) {
            initArray.push(null);
          }
        }
        const finalObject = {};
        finalObject['documentAllowedTypes'] = documentData.data.documentAllowedTypes[item];
        finalObject['documentCodesToFriendlyNames'] = documentData.data.documentCodesToFriendlyNames[item];
        finalObject['documentRequiredNumbers'] = documentRequiredNumbers;
        finalObject['currentDocuments'] = currentDocuments;
        finalObject['helpButton'] = documentData.data.helpButtons[item];
        //this is for multiple file uploads
        finalObject['maxFiles'] = documentMaxNumber - documentRequiredNumbers + 1;
        //this is for counter on upload
        finalObject['counter'] = Array.from({ length: documentRequiredNumbers }, (_, index) => 1);
        //this is the fileArray
        finalObject['fileArray'] = initArray;
        
        
        return finalObject
      })

     setItems(itemsList)
    }
  },[documentData])

  const isDisabled = useMemo(() => {
    return items.findIndex(item => 
      item.fileArray.findIndex(innerItem => innerItem === null) !==-1
    ) !== -1;
  }, [items]);

  const handleUpload = (newArray, indexItem, index) => {
    let formData = new FormData();
    let jsonData = "";
    
    let typeName = `mimeType`;
    
    jsonData = newArray[index];
    formData.set('document', newArray[index]);
    formData.set(typeName, jsonData["type"].split('/')[1]);
    formData.set('counter', items[indexItem].counter[index] === undefined ? 1 : items[indexItem].counter[index]);
    formData.set('docCode', documentData.data.requiredDocuments[indexItem]);
    formData.set('fileIndex', index);
    formData.set('cnCode', orderId);
    setSave(true)
    saveFile({ cncode: orderId, data: formData },
      {
        onSuccess: (data) => {
          setSave(false)
          if (data.data.status === 'success') {
            //update the files
            let updatedItems = [...items];
            let updatedArray = [...items[indexItem].fileArray];
            if (updatedArray[index] !== undefined) {
              updatedArray[index] = newArray[index];
            } else {
              updatedArray.push( newArray[index])
            }
            updatedItems[indexItem].fileArray = updatedArray;

            //update the counter
            if (updatedItems[indexItem].counter[index] !== undefined) {
              updatedItems[indexItem].counter[index] = items[indexItem].counter[index] + 1;
            } else {
              let updatedCounterList = updatedItems[indexItem].counter;
              updatedCounterList.push(2);
              updatedItems[indexItem].counter = updatedCounterList
            }

            setItems(updatedItems);
          } else {
            let updatedItems = [...items];

            //update the counter
            if (updatedItems[indexItem].counter[index] !== undefined) {
              updatedItems[indexItem].counter[index] = items[indexItem].counter[index] + 1;
            } else {
              let updatedCounterList = updatedItems[indexItem].counter;
              updatedCounterList.push(2);
              updatedItems[indexItem].counter = updatedCounterList
            }

            setItems(updatedItems);

            toast({
              variant: 'destructive',
              description: data.exceptions[0] ?? 'Something went wrong',
            });
          }
      }
    })
  }

  return (
    <>
      {save && <Loader className="fill-primary" />}
      <div className="flex border-b pb-2  border-b-[#A5A5A5] justify-between">
        <div className="flex gap-2 pl-4 items-center max-lg:z-[100]">
          <div className="flex gap-2">
            <FileIcon className={'stroke-black'}/>
            <h5>Στοιχεία & Έγγραφα</h5>
          </div>
          <p className="text-body max-lg:hidden">• Bήμα 2/2</p>
          <p className="text-body lg:hidden">Bήμα 2/2</p>
          <TooltipComponent side={'bottom'} content={<p className='flex flex-wrap lg:w-[300px] w-[200px]'>Τα δικαιολογητικά που θα υποβληθούν σε αυτό το στάδιο πρέπει να ανήκουν στο άτομο που θα υπογράψει τα συμβόλαια στα επόμενα βήματα.</p>}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.416504" y="0.75" width="16.5" height="16.5" rx="8.25" stroke="#A5A5A5" strokeWidth="0.5"/>
                            <path d="M8.66748 6.3396V6.33301" stroke="#6A6A6A" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.66748 11.666V7.93262" stroke="#6A6A6A" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.6667 14.2002C11.5386 14.2002 13.8667 11.8721 13.8667 9.0002C13.8667 6.12832 11.5386 3.8002 8.6667 3.8002C5.79482 3.8002 3.4667 6.12832 3.4667 9.0002C3.4667 11.8721 5.79482 14.2002 8.6667 14.2002Z" stroke="#6A6A6A" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </TooltipComponent>
          </div>
          <Button  disabled={isDisabled || isLoading} onClick={onStepCompleted}  className={'max-lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-full text-white text-sm font-[600]'}>Επόμενο</Button>
      </div>
      {message !== '' &&
                        <div className="p-3 bg-[#FFD5D5] rounded-[12px] mt-4 text-body">
                          {message}
                        </div>}
      <div className="py-10 max-lg:pb-20 px-4 lg:px-16 grid gap-14 lg:container lg:mx-auto">
        {items.map((item, indexItem) => (
          <UploadFilesCard
            disabled={save}
            key={indexItem}
            uploadCase={item}
            onChange={(newArray, index) => {
              handleUpload(newArray, indexItem, index)
            }}
          />
        ))}
        <Button  disabled={isDisabled || isLoading} onClick={onStepCompleted} className={'lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-[6px] text-white text-sm font-[600]'}>Επόμενο</Button>    
      </div>
    </>
  );
};
